<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface GrammarIconProps {
  iconTemplate: IconConstant | '';
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  nofill?: boolean;
}

const props = withDefaults(defineProps<GrammarIconProps>(), {
  size: 'medium',
  nofill: false,
});
</script>

<template>
  <tpg-icon v-bind="props" />
</template>
